import {
  AccountholderFormVM,
  ApplicantFormVM,
  CertificateValueBorn,
  CertificateValueCitizenship,
  CertificateValueCivilUnion,
  CertificateValueDeath,
  CertificateValueMarriage,
  CertificationFormVM,
} from 'civil-status/view-models/document-birth-form';
import { ObjectShape } from 'yup/lib/object';
import * as yup from 'yup';
import { regexOnlyStringNumericWithSpecialCharacters } from 'shell/constants/regex';
import { CertificationStep } from 'civil-status/constants/certification-step';

const createSchema = (active: CertificationStep): yup.AnyObjectSchema => {
  let schemaObject: ObjectShape = {};

  if (active === CertificationStep.ApplicantAccountholder) {
    schemaObject = {
      flagInternal: yup.boolean(),
      applicant: yup.object().shape({
        searchApplicant: yup.boolean(),
        fiscalCode: yup.string(),
        // .matches(fiscalCodeRegex, 'Il campo deve essere un codice fiscale'),
        surname: yup
          .string()
          .matches(regexOnlyStringNumericWithSpecialCharacters, 'Campo non valido'),
        name: yup.string().matches(regexOnlyStringNumericWithSpecialCharacters, 'Campo non valido'),
        reasonRelease: yup.string().nullable(),
        gender: yup.string(),
        isForeign: yup.boolean(),
        birthDate: yup.date().nullable().typeError('Data non valida'),
        municipality: yup.object().shape({}).nullable(),
        foreignState: yup.object().shape({}).nullable(),
        foreignMunicipality: yup.object().shape({}).nullable(),
        documentNumber: yup.string(),
        documentIssuedDate: yup.date().nullable().typeError('Data non valida'),
        municipalityDocument: yup.object().shape({}).nullable(),
      }),

      accountholder: yup
        .object()
        .shape({
          reasonRelease: yup.string(),
          fiscalCode: yup.string(),
          surname: yup.string(),
          withoutSurname: yup.boolean(),
          name: yup.string(),
          withoutName: yup.boolean(),
          gender: yup.string(),
          birthDate: yup.date().nullable().typeError('Data non valida'),
          sameAsApplicant: yup.boolean(),
        })
        .test('accountHolder', 'Campo obbligatorio', (values) => {
          const valuesCasted = values as unknown as AccountholderFormVM;

          // same as applicant
          if (valuesCasted?.sameAsApplicant) {
            return true;
          }

          // // fiscal code required
          // if (!valuesCasted?.fiscalCode) {
          //   return new yup.ValidationError(
          //     'Campo obbligatorio',
          //     undefined,
          //     'accountholder.fiscalCode'
          //   );
          // }

          // search required
          if (!valuesCasted?.searchAccountholder) {
            return new yup.ValidationError(
              'Effettuare ricerca',
              undefined,
              'accountholder.searchAccountholder'
            );
          }

          return true;
        }),
    };
  }
  if (active === CertificationStep.ChooseCertificate) {
    schemaObject = {
      releaseMode: yup.object().shape({}).nullable(),
      certificate: yup.object().shape({}).nullable().required('Tipo certificato obbligatorio'),
      flagInternal: yup.boolean(),
      flagCarta: yup.boolean(),
      requiredTypeUse: yup.boolean(),
      typeUse: yup.string().when('requiredTypeUse', {
        is: (requiredTypeUse: boolean) => requiredTypeUse,
        then: yup.string().nullable().required('Campo obbligatorio'),
        otherwise: yup.string().nullable().notRequired(),
      }),
      // typePayment: yup.string().when(['flagInternal', 'flagCarta', 'releaseMode'], {
      //   is: (flagInternal: boolean, flagCarta: boolean, releaseMode?: ModalityPaymentVM) =>
      //     flagInternal || flagCarta || releaseMode?.id === ID_PPAA2,
      //   then: yup.string().nullable().notRequired(),
      //   otherwise: yup.string().nullable().required('Campo obbligatorio'),
      // }),
    };
  }
  if (active === CertificationStep.Search) {
    schemaObject = {
      chosenDocument: yup.object().nullable().required('Campo obbligatorio'),
    };
  }
  if (active === CertificationStep.Visualize) {
    schemaObject = {};
  }

  return yup
    .object()
    .shape(schemaObject)
    .test('', '', (values) => {
      const castedValues = values as unknown as CertificationFormVM;

      if (active !== CertificationStep.ApplicantAccountholder) {
        return true;
      }

      if (!castedValues.flagInternal) {
        let keys = [
          // 'municipality',
          // 'municipalityDocument',
          'birthDate',
          'documentIssuedDate',
          'documentNumber',
          'gender',
          'surname',
          'name',
        ] as Array<keyof ApplicantFormVM>;

        const applicantValues = castedValues.applicant || {};

        if (applicantValues.isForeign) {
          keys = [...keys, 'foreignState', 'foreignMunicipality'];
        } else {
          keys = [...keys, 'municipality'];
        }

        if (applicantValues.isForeignDocument) {
          keys = [...keys, 'foreignStateDocument'];
        } else {
          keys = [...keys, 'municipalityDocument'];
        }

        const errors = keys
          .map((key) => {
            if (applicantValues[key]) {
              return null;
            } // Successful validation, no error

            return new yup.ValidationError(
              'Il campo è obbligatorio',
              applicantValues[key],
              `applicant.${key}`
            );
          })
          .filter((item) => !!item) as unknown as Array<yup.ValidationError>;
        if (errors.length === 0) {
          return true;
        }
        return new yup.ValidationError(errors);
      }
      return true;
    })
    .test('', '', (values) => {
      const castedValues = values as unknown as CertificationFormVM;

      if (active !== CertificationStep.ChooseCertificate) {
        return true;
      }

      const isCopia =
        castedValues.certificate?.element?.key?.codiceDocumento === CertificateValueBorn.copia ||
        castedValues.certificate?.element?.key?.codiceDocumento ===
          CertificateValueMarriage.copia ||
        castedValues.certificate?.element?.key?.codiceDocumento === CertificateValueDeath.copia ||
        castedValues.certificate?.element?.key?.codiceDocumento ===
          CertificateValueCivilUnion.copia ||
        castedValues.certificate?.element?.key?.codiceDocumento ===
          CertificateValueCitizenship.copia;

      if (isCopia && !castedValues.chosenDocument?.isAnsc) {
        const keys = ['timber', 'reason'] as Array<keyof CertificationFormVM>;
        const errors = keys
          .map((key) => {
            if (castedValues[key]) {
              return null;
            } // Successful validation, no error

            return new yup.ValidationError('Il campo è obbligatorio', castedValues[key], key);
          })
          .filter((item) => !!item) as unknown as Array<yup.ValidationError>;
        if (errors.length === 0) {
          return true;
        }
        return new yup.ValidationError(errors);
      }
      return true;
    })
    .test('', '', (values) => {
      const castedValues = values as unknown as CertificationFormVM;

      if (active !== CertificationStep.ApplicantAccountholder) {
        return true;
      }

      if (castedValues.flagInternal && !castedValues.accountholder?.reasonRelease) {
        return new yup.ValidationError(
          'Il campo è obbligatorio',
          undefined,
          'accountholder.reasonRelease'
        );
      }
      return true;
    });
};

export default createSchema;
